var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlioblastoma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_20523",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 9,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9948 2H3V22H11.9948V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_20523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0044 3.88969C11.4984 2.70763 10.1146 2.41211 9.31937 3.36198C8.92694 3.82636 8.65843 4.4385 8.56549 5.11396L8.49319 5.16673C6.71694 5.45169 5.13692 6.66541 5.02332 8.74457C5.02332 8.74457 4.53796 8.93454 4.12488 9.70499C3.52591 10.8343 3.69114 12.6812 4.50697 13.6206C4.92005 14.0955 5.38478 14.3593 5.71525 14.3593C5.71525 14.3593 4.3211 17.6522 7.32626 18.3805L7.42951 18.4121C7.59474 19.1615 7.93554 19.8264 8.37961 20.3435C9.35035 21.4517 10.9201 21.4517 11.9941 20.4702V3.86858L12.0044 3.88969Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2071_20523",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 2,
    width: 9,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0007 2H12.0059V22H21.0007V2Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2071_20523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0059 3.88969C12.5119 2.70763 13.8957 2.41211 14.6909 3.36198C15.0833 3.82636 15.3518 4.4385 15.4447 5.11396L15.517 5.16673C17.2933 5.45169 18.8733 6.66541 18.9869 8.74457C18.9869 8.74457 19.4723 8.93454 19.8854 9.70499C20.4843 10.8343 20.3191 12.6812 19.5033 13.6206C19.0902 14.0955 18.6255 14.3593 18.295 14.3593C18.295 14.3593 19.6892 17.6522 16.684 18.3805L16.5807 18.4121C16.4155 19.1615 16.0747 19.8264 15.6306 20.3435C14.6599 21.4517 13.0902 21.4517 12.0162 20.4702V3.86858L12.0059 3.88969Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2071_20523",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 7,
    width: 5,
    height: 4
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60845 7.68945H3.60156V10.1591H7.60845V7.68945Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2071_20523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83284 8.7444C6.83284 8.7444 5.68653 7.8473 4.375 9.36709",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2071_20523",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 7,
    width: 5,
    height: 4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4561 7.68945H16.4492V10.1591H20.4561V7.68945Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2071_20523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2227 8.7444C17.2227 8.7444 18.369 7.8473 19.6805 9.36709",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2071_20523",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 12,
    width: 6,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28779 12.9648H4.64062V18.854H9.28779V12.9648Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2071_20523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.088 13.7568C7.088 13.7568 5.81777 13.8518 5.46665 15.4349C5.2188 16.5748 5.67321 18.8122 8.51314 17.8096",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2071_20523",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 12,
    width: 6,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4089 12.9648H14.7617V18.854H19.4089V12.9648Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2071_20523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9505 13.7568C16.9505 13.7568 18.2207 13.8518 18.5718 15.4349C18.8197 16.5748 18.3653 18.8122 15.5254 17.8096",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlioblastoma);
export default __webpack_public_path__ + "static/media/Glioblastoma.06a419393806f62d4db4e96c2f2b2566.svg";
export { ForwardRef as ReactComponent };